import React from 'react';

import './RequiredSpan.scoped.scss';

interface Props {
  required?: boolean;
}

const style = {
  color: '#FF0000',
  paddingRight: '5px',
};

const RequiredSpan: React.FC<Props> = ({ required }) => {
  return required ? <span style={style}>*</span> : <div />;
};

export default RequiredSpan;
